import { render } from "./SortableTh.vue?vue&type=template&id=9f5bbb72"
import script from "./SortableTh.vue?vue&type=script&lang=js"
export * from "./SortableTh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__